import { bannerApi } from '@/api'

export const fetchCourseBanners = async (): Promise<Banner[]> => {
  try {
    const res = await bannerApi.index({
      params: { group: 'course' },
    })

    return res?.data ?? []
  } catch (error) {
    console.error('Ошибка загрузки банеров:', error)
    return []
  }
}
